import { CommercialSegment } from "./commercialSegment"
import { Country } from "./country"

export enum VisitorType {
    NonProfessional = 'NonProfessional',
    NewProfessional = 'NewProfessional',
    ErpProfessional = 'ErpProfessional'
}

export interface VisitorCreateDTO {
    id?: string
    firstName: string
    lastName: string
    email: string
    type: VisitorType
    erpCode?: string | null
    representsPurchaseGroup?: boolean | null
    commercialSegmentId?: string | null
    functionaryId?: string | null
    agentId?: string | null
    countryId?: string | null
    businessName?: string | null
    role?: string | null
    activitySector?: string | null
}

export interface VisitorDTO {
    id: string
    firstName: string
    lastName: string
    email: string
    type: VisitorType
    erpCode: string | null
    representsPurchaseGroup: boolean | null
    commercialSegmentId: string | null
    functionaryId: string | null
    agentId: string | null
    countryId: string | null
    businessName: string | null
    role: string | null
    activitySector: string | null
}

export interface Visitor {
    id: string
    firstName: string
    lastName: string
    email: string
    type: VisitorType
    erpCode: string | null
    representsPurchaseGroup: boolean | null
    commercialSegment: CommercialSegment | null
    functionaryId: string | null
    functionaryName: string | null
    agentId: string | null
    agentName: string | null
    country: Country | null
    businessName: string | null
    role: string | null
    activitySector: string | null
}